let gformEventFallbackInitialized = false;

function initGformEventFallback() {
	if (gformEventFallbackInitialized) {
		return;
	}

	['click', 'submit', 'change', 'input'].forEach((eventName) => {
		document.addEventListener(
			eventName,
			(evt) => {
				window.event = evt;
			},
			true
		);
	});

	gformEventFallbackInitialized = true;
}

export function setGformHoneypot() {
	if (!window.WPDATA.gforms_installed) {
		return;
	}

	initGformEventFallback();

	if (typeof jQuery == 'undefined') {
		return;
	}

	jQuery(document).on('submit', 'form[data-formid]', function (evt) {
		const el = evt.target;
		if (!el.querySelector('[name="version_hash"]')) {
			const hiddenInput = `<input
				type="hidden"
				name="version_hash"
				value="${window.gform_theme_config?.common?.form?.honeypot?.version_hash}"
			/>`;
			el.insertAdjacentHTML('beforeend', hiddenInput);
		}
	});
}

export function evalScripts(next) {
	if (!window.WPDATA.gforms_installed) {
		return;
	}

	var parser = new DOMParser();
	var htmlDoc = parser.parseFromString(next.html, 'text/html');
	const scripts = htmlDoc.getElementsByTagName('script');

	function evalInWindow(src) {
		const func = function () {
			eval(src);
		};

		// Define event to prevent errors in gform javascript
		const backup = window.event;
		window.event = {};
		func.call(window);
		delete window.event;

		if (backup !== undefined) {
			window.event = backup;
		}
	}

	[...scripts].forEach((script) => {
		if (script.hasAttribute('data-barba-include')) {
			let src = script.innerHTML;

			try {
				// console.log({ src });
				evalInWindow(src);
			} catch (e) {
				console.error(e);
			}
		}
	});
}
